// THIS FILE IS COMPOSED BY COPYING SOME OF THE BACKEND ROUTES WHICH CANT BE IMPORTED FROM THE BACKEND DUE TO CIRCULAR DEPENDENCIES
export const BackendRoutes = {
  CUSTOMER_PROFILE_USER_PROFILE: '/api/v1/user/profile',

  DEALER_PREFERENCES: '/api/v1/user/preferences/dealers',
  DEALER_PREFERENCES__DEALER_ID: '/api/v1/user/preferences/dealers/:dealerId',
  DEALER_NPS: '/api/v1/user/nps',
  DEALER_NPS__DEALER_ID: '/api/v1/user/nps/:dealerId',
  DEALERS: '/api/v1/user/dealers',
  LOCATION: '/api/v1/user/location',
};
